<template>
  <div class="result_list" :item="item" @click="showDetail" :key="item.spec_id">
    <header class="result_list_name">{{item.name}}</header>
    <div class="result_list_detail" >
        <span>{{item.width_px}}*{{item.height_px}}px</span>
        <span>{{item.width_mm}}*{{item.height_mm}}mm</span>
        <span v-if="isSize">{{size}}</span>
    </div>
		<img src="../assets/icon_arrow.png" class='arrow' />
</div>
</template>

<script>
import { caculateSize } from '../utils/utils';

export default {
  props:['item'],
  methods: {
    showDetail: function() {
      let {spec_id, name} = this.item;
      const specInfo = {
        specId: spec_id,
        specName: name
      }
      this.$emit('showDetailInfo', specInfo);
    }
  },
  computed: {
    isSize: function() {
      return this.item.file_size_min || this.item.file_size_max;
    },
    size: function() {
      if(this.isSize) {
        return caculateSize(this.item.file_size_min, this.item.file_size_max);
      }
    }
  }
}
</script>

<style>
.result_list{
  position: relative;
  background-color: #FFF;
  border-top:solid 1px #EEE;
  border-bottom:solid 1px #EEE;  
  padding: 0 1em;
  height: 100px;
	margin: 10px;
 }
 .result_list_name{
  margin: 23px 0 .5em 0;
  color: #333333;
  font-size: 16px;
 }
 .result_list_detail{
	display: inline-flex;
  margin: 0 0 23px 0;
 }
.result_list_detail span{
  margin-right: 1em;
  color: #999999;
  font-size: 12px;
}
.arrow{
  width: 7px;
  height: 12px;
  position: absolute;
  top: 44px;
  right: 44px;
}
</style>
